module.exports = __webpack_public_path__ + "static/media/companyLogoSquare.eb22bd06.png";